import { PlanActionMode } from '@aibees/shared/definition';
import { SubscriptionFlow } from '../types';
import { useDowngradeToFreeFlow } from './use-downgrade-to-free-flow';
import { useDowngradToPaidFlow } from './use-downgrad-to-paid-flow';
import { useUpgrade } from './use-upgrade';
import { useCancelSchedulePlanFlow } from './use-cancel-schedule-plan-flow';

export function useSubscriptionFlow(
  actionMode: PlanActionMode | null
): SubscriptionFlow {
  const downgradeFreeFlow = useDowngradeToFreeFlow();
  const downgradePaidFlow = useDowngradToPaidFlow();
  const cancelFlow = useCancelSchedulePlanFlow();
  const upgradeFlow = useUpgrade();

  switch (actionMode) {
    case PlanActionMode.DOWNGRADE_FREE:
      return downgradeFreeFlow;
    case PlanActionMode.DOWNGRADE_PAID:
      return downgradePaidFlow;
    case PlanActionMode.UPGRADE:
      return upgradeFlow;
    case PlanActionMode.CANCEL_DOWNGRADE:
      return cancelFlow;

    default:
      return downgradeFreeFlow;
  }
}
